import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('GigiInfoModal').create(({ theme }) => ({
  root: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    padding: '16px',
    gap: '6px',
    height: 'auto',
    borderRadius: theme.sizes.radiuses.xl,
    border: '1px solid',
    borderColor: theme.colors.borders.default,
    background: 'rgba(255, 255, 255, 0.10)',
    backdropFilter: 'blur(70px)',
    span: {
      fontSize: theme.sizes.texts.fontSize.s,
      color: theme.colors.text.primary,
      fontWeight: 350,
    },
  },

  iconWrapper: {
    width: 'fit-content',
    height: '100%',
  },
}))
